import axios from "./axiosConfig";

export function logout() {
  localStorage.removeItem("jwt_token");
  delete axios.defaults.headers.common["Authorization"];
  window.location.href = "/wiki/";
}
